module.exports = __webpack_public_path__ + "img/cloud.cab43fde.png";